module.exports = __webpack_public_path__ + "static/media/stressActive.3c011448.svg";